import { useTranslation } from '@mint-lib/i18n';
import { ArrowLeft } from '@mint-lib/icons';
import { Link as RouterLink } from '@mint/routing';

import { Link } from '@myn/mui';

import { useIntegrationPaths } from '../../../hooks/useIntegrationsRouteApi.js';

const GoBackLink = () => {
  const { t } = useTranslation('@myn/integrations_v2');
  const paths = useIntegrationPaths();

  return (
    <div className="mb-3">
      <Link
        className={
          'flex max-w-none items-center gap-1 border-0 visited:text-text-link hover:no-underline'
        }
        component={RouterLink}
        to={paths.integrations}
        variant={'bodyShort01'}
        data-dd-action-name="back to integrations"
      >
        <ArrowLeft />
        {t('Back to Integrations')}
      </Link>
    </div>
  );
};

export default GoBackLink;
